export class FormattingUtils
{
  /** Returns strings representing the hex values in the data
   * @param {number[] | Uint8Array} data
   */
  static toHexStrings(data) {
		//return data.map(function(d){return d.toString(16);});
		// Ugly, but works with both Uint8Array and Array:
		var arr = [];
		for (var i = 0; i < data.length; i++) {
			arr.push(data[i].toString(16));
		}
		return arr;
	}

  /** Returns a string representing the hex values in the data
   * @param {number[] | Uint8Array} data
   */
  static toHexString(data) {
    return '[' + this.toHexStrings(data).join(', ') + ']';
  }

  /** Returns true iff there are non-printable characters in str */
  static hasNonPrintableChars(str) {
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      if (char < 0x20 || char > 126) return true;
    }
    return false;
  }

  /** Replaces any non-printable characters in str with replacement */
  static replaceNonPrintableChars(str, replacement = ' ') {
    let result = '';
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      if (char < 0x20 || char > 126) result += replacement;
      else result += String.fromCharCode(char);
    }
    return result;
  }

  static dumpObject(obj, indent = 0) {
    if (typeof(obj) !== 'object') throw new Error('dumpObject(): not of type object');
    let s = ' '.repeat(indent);
    s += '{\n';
    Object.entries(obj).forEach(function([key,val]) {
      s += ' '.repeat(indent + 2);
      s += key + ': ';// + '\n';
      if (typeof(val) == 'object') {
        s += '\n' + FormattingUtils.dumpObject(val, indent + 2) + '\n';
      } else {
        s += val + '\n';
      }
    });
    s +=' '.repeat(indent) + '}';
    return s;
  }


  /** Returns a string with a hex dump of the data
   * (for debugging etc)
   * @param {number[] | Uint8Array} data
   */
  static toHexDump(data, bytesPerColumn = 4, numColumns = 4,
    showOffset = true, showAscii = true)
  {
    let length = data.length;
    let dataStrWidth = numColumns * (bytesPerColumn*3 + 1);

    let offset = 0;
    let result = '';
    while (offset < data.length) {
      let offsetStr = '';
      if (showOffset) {
        offsetStr += offset.toString(10).padEnd(6); // offset in dec
      };

      let dataStr ='';
      let asciiStr = '   ';
      for (let col = 0; col < numColumns && offset < data.length; col++) {
        for (let byte = 0; byte < bytesPerColumn && offset < data.length; byte++) {
          let dataByte = data[offset];
          if (typeof dataByte != 'number') {
            dataStr += '-- ';
            asciiStr += ' ';
          }
          dataStr += dataByte.toString(16).padStart(3);
          if (dataByte >= 0x20 && dataByte <= 0x7e) { // printable
            asciiStr += String.fromCharCode(dataByte);
          } else {
            asciiStr += ' ';
          }

          offset++;
        }
        dataStr += ' '; // column gap
      }
      dataStr = dataStr.padEnd(dataStrWidth);

      result += offsetStr;
      result += dataStr;
      if (showAscii) result += asciiStr;
      result += '\n';
    }
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/parsing_formatting/formattingutils.js